import { render, staticRenderFns } from "./Erms.vue?vue&type=template&id=5b7e9080&"
import script from "./Erms.vue?vue&type=script&lang=js&"
export * from "./Erms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports